// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Icon type classification.
 */
export enum IconType {
  STATUS = 0,
  ACTION = 1,
  SINGLEDOOR = 2,
  DOUBLEDOOR = 3,
}
